import React from 'react';
import TeamUpgradeInfo from './TeamUpgradeInfo';
import useAppSelector from '../app/redux/useAppSelector';
import Menu, { MenuItem, MenuSeparator } from '../components/Menu';
import { HelpMenuItem } from '../help/HelpMenu';
import insightsIcon from '../icons/non-prefilled/16x16/insights.svg';
import settingsIcon from '../icons/non-prefilled/16x16/settings.svg';
import teamIcon from '../icons/non-prefilled/16x16/team.svg';
import ReferralMenuItem from '../user/ReferralMenuItem';

const TeamMenu = () => {
  const isAdmin = useAppSelector(
    (state) => state.session.user.type === 'ADMIN',
  );

  return (
    <Menu>
      {isAdmin && (
        <>
          <MenuItem icon={settingsIcon} to="/admin/appearance">
            Team settings
          </MenuItem>

          <MenuItem icon={teamIcon} to="/admin/teammates">
            Teammates
          </MenuItem>

          <MenuItem icon={insightsIcon} to="/admin/insights">
            Insights
          </MenuItem>
          <MenuSeparator />
        </>
      )}
      <MenuItem to="https://go.slab.com/product-updates" newTab>
        Product updates
      </MenuItem>
      <MenuItem to="https://go.slab.com/slab-university" newTab>
        Slab University
      </MenuItem>
      <ReferralMenuItem showIcon={false} />
      <HelpMenuItem />
      {isAdmin && <TeamUpgradeInfo />}
    </Menu>
  );
};

export default TeamMenu;
